<script lang="ts" setup>
import { useAuthStore } from "@/features/auth/store";
import NavBarItem from "./NavBarItem.vue";

const authStore = useAuthStore();

const loginUrl =
  import.meta.env.VITE_API_URL +
  "/login" +
  "?next=" +
  encodeURIComponent(window.location.href);
</script>

<template>
  <nav
    class="fixed print:hidden w-[calc(100%-16rem)] right-0 top-0 z-10 bg-slate-300 text-slate-900"
  >
    <div class="flex items-center justify-between h-6 pl-2">
      <div class="hidden md:block">
        <NavBarItem><router-link to="/">Start</router-link></NavBarItem>
      </div>
      <div
        class="items-center justify-end hidden h-6 divide-x-2 md:flex divide-slate-400"
      >
        <template v-if="authStore.isAuthenticated && authStore.user">
          <NavBarItem>{{ authStore.user.name }}</NavBarItem>
          <NavBarItem>
            <a :href="authStore.getLogoutUrl()">Logout</a>
          </NavBarItem>
        </template>
        <template v-else>
          <NavBarItem><a :href="loginUrl">Login</a></NavBarItem>
        </template>
      </div>
    </div>
  </nav>
</template>
